import React from "react";
import { createRoot } from "react-dom/client";
import { BrowserRouter } from "react-router-dom";
import { GoogleOAuthProvider } from "@react-oauth/google";
import { registerSW } from "virtual:pwa-register";
import App from "./App";
import { AuthProvider } from "./context/AuthContext";
import TourProvider from "./tour/TourProvider";
import "./css/App.css";

registerSW({ immediate: true });

const googleClientId = import.meta.env.VITE_GOOGLE_CLIENT_ID || "";
const appTree = (
  <BrowserRouter>
    <AuthProvider>
      <TourProvider>
        <App />
      </TourProvider>
    </AuthProvider>
  </BrowserRouter>
);

createRoot(document.getElementById("root")).render(
  <React.StrictMode>
    {googleClientId ? (
      <GoogleOAuthProvider clientId={googleClientId}>{appTree}</GoogleOAuthProvider>
    ) : (
      appTree
    )}
  </React.StrictMode>
);
